<template>
  <loadable-content>
    <worksheet-form />
  </loadable-content>
</template>

<script>
  import { WorksheetService } from '@pbx/services/WorksheetService';
  import WorksheetForm from '@pbx/components/worksheets/form';
  import { mapActions } from 'vuex';

  export default {
    components: { WorksheetForm },
    created() {
      const id = this.$route.params.id;

      WorksheetService.getScheme(id)
        .then((res) => {
          return Promise.all([
            this.setId(res.id),
            this.setActions(res.items),
            this.setLastSaveActions(res.items)
          ]);
        })
        .catch((e) => this.showPageError(e))
        .finally(() => this.endLoadingPage());
    },

    methods: {
      ...mapActions('pbx/worksheets/form', ['setId', 'setActions', 'setLastSaveActions'])
    }
  };
</script>
